import {
  Box,
  Icon,
  Text,
  Tooltip,
  useClassNames,
  useToggle,
} from '@factorialco/deprecated-design-system'
import { Moment } from 'moment'

import i18n from 'modules/core/lib/i18n'

import * as stylesRefs from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'
import {
  RowType,
  ScheduleRecordValuesType,
} from 'modules/project_management/components/Schedule/Body/ScheduleItem/types'

import SubRow from './SubRow'

interface IRowProps {
  days: Moment[]
  dataRow: RowType
  openSidepanel: (data?: ScheduleRecordValuesType | null) => void
}

const Row = ({ days, dataRow, openSidepanel }: IRowProps) => {
  const cx = useClassNames(stylesRefs)
  const [open, toggle] = useToggle(false)

  return (
    <Box className={cx('scheduleItemRow')}>
      <Box
        className={cx('scheduleItemFirstColumn')}
        paddingLeft="s48"
        paddingTop="s8"
        paddingRight="s8"
      >
        <Box flexDirection="row" gap="s4" alignItems="center">
          <Text.Normal size="100" weight="medium" color="grey1000" ellipsis>
            {dataRow.firstColumn.title}
          </Text.Normal>
          {dataRow.otherAssignments && (
            <Tooltip.Alt
              open={open}
              toggle={toggle}
              attachment="middle left"
              label={i18n.t('project_management.schedule.other_assignments.tooltip')}
            >
              <Icon.Medium icon="info-circle-line" color="grey700" />
            </Tooltip.Alt>
          )}
        </Box>

        <Text.Normal size="100" weight="normal" color="grey1000" ellipsis>
          {dataRow.firstColumn.subtitle}
        </Text.Normal>
      </Box>
      <Box flexDirection="column">
        {Object.keys(dataRow.records).map((key) => (
          <SubRow
            key={key}
            days={days}
            records={dataRow.records[key]}
            openSidepanel={openSidepanel}
          />
        ))}
      </Box>
    </Box>
  )
}

export default Row
